function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24 14.9999C24 15.526 23.852 16.0138 23.6149 16.4429L16.0371 7.96446L23.5328 1.40646C23.8244 1.86919 24 2.41273 24 3.00011V14.9999ZM12 9.5039L22.4299 0.377974C22.0019 0.143668 21.52 -2.19345e-05 21.0001 -2.19345e-05H2.99998C2.47943 -2.19345e-05 1.99732 0.143668 1.57104 0.377974L12 9.5039ZM14.9078 8.9518L12.4936 11.0655C12.3524 11.1886 12.1765 11.25 12 11.25C11.8234 11.25 11.6476 11.1886 11.5064 11.0655L9.0916 8.9517L1.41796 17.5385C1.87791 17.8271 2.41696 18 2.99993 18H21.0001C21.5829 18 22.1222 17.8271 22.582 17.5385L14.9078 8.9518ZM0.467327 1.40641C0.175792 1.86914 0 2.41269 0 3.00011V14.9999C0 15.5261 0.147301 16.0138 0.385267 16.443L7.96216 7.96303L0.467327 1.40641Z",
  fill: "#29394D"
});

var SvgClosedEnvelop = function SvgClosedEnvelop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClosedEnvelop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closed-envelop.9c308444.svg";
export { ForwardRef as ReactComponent };